export class GraphColors {
  static readonly hoverBackground: string = 'ccd6eb';
}
